<app-module-error *ngIf="somethingWentWrong && !isDataLoading"></app-module-error>
<overlay-scrollbars [options]="scrollOptions" class="scrollbar mt-2">
    <div [hidden]="!noData" class="error-container">
        <svg class="error-icon">
            <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
        </svg>
        <p class="cxone-error-text" cvLocalizedText langSection="Games_Module" langKey="CXone_Data_Error">No data available</p>
    </div>
    <div *ngIf="gamesData" #gamesDiv [attr.id]="moduleKey">
        <div *ngFor="let currentGame of currentGames; trackBy: trackItem" [attr.id]="currentGame?.underlyingRule?.RuleID" #cardDivOngoing>
            <cxone-game-card [hidden]="noData" [game]="currentGame" gameStatus="Ongoing" [rankingData]="findObjectByRuleID(currentGame?.underlyingRule?.RuleID)"></cxone-game-card>
        </div>

        <div *ngFor="let upcomingGame of upcomingGames; trackBy: trackItem" [attr.id]="upcomingGame?.underlyingRule?.RuleID">
            <cxone-game-card [hidden]="noData" [game]="upcomingGame" gameStatus="Upcoming" [rankingData]="findObjectByRuleID(upcomingGame?.underlyingRule?.RuleID)"></cxone-game-card>
        </div>

        <div *ngFor="let endedGame of endedGames; trackBy: trackItem" [attr.id]="endedGame?.underlyingRule?.RuleID" #cardDivEnded>
            <cxone-game-card [hidden]="noData" [game]="endedGame" gameStatus="Ended" [rankingData]="findObjectByRuleID(endedGame?.underlyingRule?.RuleID)"></cxone-game-card>
        </div>
    </div>
</overlay-scrollbars>